import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'

import { register } from 'actions'
import {
  registerErrorSelector,
  registerEmailErrorSelector,
  registerPasswordErrorSelector,
  isAuthenticatedSelector,
} from 'selectors'

import { Form, Field, Input, FormContainer } from 'components/form'
import ButtonComponent from 'components/Button'
import Error from 'components/Error'

const FormWrapper = styled(FormContainer)`
  margin: auto;
`

const Button = styled(ButtonComponent)`
  margin-top: 10px;
  width: 186px;
  align-self: center;
`

class Register extends React.Component {
  state = {
    name: this.props.name,
    email: this.props.email,
    password: '',
  }

  componentDidMount() {
    document.body.style.backgroundColor = '#5F4B76'
  }

  componentWillUnmount() {
    document.body.style.backgroundColor = ''
  }

  register = e => {
    e.preventDefault()
    this.props.register(this.state)
  }

  render() {
    if (this.props.isAuthenticated) {
      return <Redirect to="/" />
    }

    return (
      <FormWrapper small title="Ny profil">
        <Form onSubmit={this.register}>
          {this.props.error && <Error>{this.props.error}</Error>}
          <Field>
            <Input
              placeholder="Navn"
              id="name"
              type="text"
              value={this.state.name}
              onChange={e => this.setState({ name: e.target.value })}
              autoFocus={!this.props.emailError && !this.props.passwordError}
              required
            />
          </Field>
          <Field>
            <Input
              placeholder="E-post"
              id="email"
              type="email"
              value={this.state.email}
              onChange={e => this.setState({ email: e.target.value })}
              error={this.props.emailError}
              autoFocus={this.props.emailError}
            />
          </Field>
          <Field>
            <Input
              placeholder="Passord"
              id="password"
              type="password"
              value={this.state.password}
              onChange={e => this.setState({ password: e.target.value })}
              helpText={'Passordet må inneholde minst 6 bokstaver'}
              error={this.props.passwordError}
              autoFocus={!this.props.emailError && this.props.passwordError}
              required
            />
          </Field>
          <Button size="large" type="submit">
            Gå videre
          </Button>
        </Form>
      </FormWrapper>
    )
  }
}

const mapStateToProps = state => ({
  name: state.auth.name || '',
  email: state.auth.email || '',
  error: registerErrorSelector(state),
  emailError: registerEmailErrorSelector(state),
  passwordError: registerPasswordErrorSelector(state),
  isAuthenticated: isAuthenticatedSelector(state),
})

const mapDispatchToProps = { register }

export default connect(mapStateToProps, mapDispatchToProps)(Register)



// WEBPACK FOOTER //
// ./src/pages/Register.js